var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-dot",attrs:{"data-placement":_vm.placement}})
}
var staticRenderFns = []

export { render, staticRenderFns }